import React, { useEffect, useMemo, useState } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    createTheme, Dialog, DialogActions, DialogContent, DialogTitle,
    IconButton, Paper,
    Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField,
    ThemeProvider,
    Tooltip, Typography
} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {
    MaterialReactTable,
    MRT_PaginationState,
    MRT_Row,
    useMaterialReactTable
} from "material-react-table";
import { getDayjsLocale, getMrtLocalization } from "../../i18n/muiAdmin";
import { t } from "../../i18n/t";
import { useGetReportsAdmin } from "../../hooks/reports";
import reportsService from "../../api/reportsService";
import authService from "../../api/authService";
import information from "../../assets/information.png";
import CanvasGrid from "../CanvasGrid";
import CanvasGridDashboard from "../CanvasGridDashboard";
import axios, {AxiosError} from "axios";
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ShortTextIcon from '@mui/icons-material/ShortText';
import {ErrorResponse, KeyValuePair, Reports, UserPair, Users} from '../../types/types';
import { useParams, useNavigate } from 'react-router-dom';
import SettingsIcon from "@mui/icons-material/Settings";
import config from "../../config";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { UserPromptsManager } from './UserPromptsManager';
import {
    downloadReportPdf,
    downloadReportXls,
    getErrorMessage,
} from '../../utils/reportDownloads';
const url = `${config.api.baseUrl}`

const formatManagerOptionLabel = (u: Users): string => {
    const name = [u.last_name, u.first_name, u.middle_name].filter(Boolean).join(' ').trim();
    const email = u.email?.trim() || '';
    const base = [name || null, email || null].filter(Boolean).join(' — ') || `#${u.id}`;
    return `${base} (#${u.id})`;
};

//const url = 'https://seemeworking.com:3066'
//const url = 'http://localhost:3000'


// @ts-ignore
const KeyValueManager = ({ userId, onClose, table}) => {

    const [keyValues, setKeyValues] = useState<KeyValuePair[]>([]);
    const [newKey, setNewKey] = useState('');
    const [newValue, setNewValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [editingItem, setEditingItem] = useState<KeyValuePair | null>(null);
    const [addingItem, setAddingItem] = useState<boolean | null>(null);
    const [isApplying, setIsApplying] = useState(false);
    const [newDescription, setNewDescription] = useState('');
    const [newImageBase64, setNewImageBase64] = useState('');

    useEffect(() => {
        const fetchKeyValues = async () => {
            setIsLoading(true);
            try {
                const response = await authService.getKeyValues(userId);
                //const data = await response.json();
                setKeyValues(response.data);
            } catch (error) {
                console.error('Ошибка загрузки:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchKeyValues();
    }, [userId]);
    // @ts-ignore
    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                // Сохраняем полный data URI (включая MIME type)
                // @ts-ignore
                setNewImageBase64(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveImage = () => {
        setNewImageBase64('');
    };

    // @ts-ignore
    const handleEditImageUpload = (event, item) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                // @ts-ignore
                const dataURI = e.target.result;
                // @ts-ignore
                const pureBase64 = dataURI.split('base64,')[1];
                // @ts-ignore
                const mimeMatch = dataURI.match(/^data:(.*?);base64/);
                const mimeType = mimeMatch ? mimeMatch[1] : 'image/jpeg';

                setEditingItem({
                    ...item,
                    imageBase64: pureBase64,
                    imageMimeType: mimeType
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // @ts-ignore
    const handleRemoveEditImage = (item) => {
        setEditingItem({
            ...item,
            imageBase64: null,
            imageMimeType: null
        });
    };

    const handleAdd = async () => {


        if (!newKey.trim()) {
            toast.warning(t('keyValue.keyEmpty'));
            return;
        }


        let pureBase64 = '';
        let mimeType = '';

        if (newImageBase64) {
            // Проверяем, содержит ли строка data URI формат
            if (newImageBase64.includes('base64,')) {
                const parts = newImageBase64.split('base64,');
                pureBase64 = parts[1];
                // Извлекаем MIME type из data URI
                const mimeMatch = newImageBase64.match(/^data:(.*?);base64/);
                mimeType = mimeMatch ? mimeMatch[1] : 'image/jpeg';
            } else {
                // Если уже чистая base64
                pureBase64 = newImageBase64;
                mimeType = 'image/jpeg'; // или другой дефолтный тип
            }
        }
        try {
            const result = await authService.createKeyValue({
                key: newKey,
                value: newValue,
                userId,
                imageBase64:pureBase64,
                description:newDescription,
                imageMimeType:mimeType
            });

            // @ts-ignore
            setKeyValues([...keyValues, result.data]);
            setNewKey('');
            setNewValue('');
            setNewImageBase64('');
            setNewDescription('');
        } catch (error: unknown) {
            console.error('Ошибка добавления:', error);

            let errorMessage = t('keyValue.addFailed');

            // Проверяем, является ли ошибка AxiosError
            if (typeof error === 'object' && error !== null && 'isAxiosError' in error) {
                const axiosError = error as AxiosError<ErrorResponse>;

                if (axiosError.response?.status === 409) {
                    errorMessage = t('keyValue.duplicateKey', { key: newKey });
                } else if (axiosError.response?.data?.message) {
                    errorMessage = axiosError.response.data.message;
                } else if (axiosError.response?.data?.error) {
                    errorMessage = axiosError.response.data.error;
                } else if (axiosError.message) {
                    errorMessage = axiosError.message;
                }
            } else if (error instanceof Error) {
                // Обычная JavaScript ошибка
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                // Строковая ошибка
                errorMessage = error;
            }
            toast.error(errorMessage, {
                autoClose: 5000,
                position: "top-right"
            });
        }
    };

    const handleDelete = async (id: number) => {
        try {
            if (!window.confirm(t('keyValue.confirmDelete'))) return;
            await authService.deleteKeyValue(id, userId);
            setKeyValues(keyValues.filter(kv => kv.id !== id));
        } catch (error) {
            // @ts-ignore
            alert(t('keyValue.errorPrefix', { message: (error as Error).message }));
        }
    };

    const handleUpdate = async (key: string, newValue: string, description:string, imageBase64:string, imageMimeType:string) => {
        try {
            // @ts-ignore
            const result = await authService.updateKeyValue({ key, value: newValue, userId, description, imageBase64, imageMimeType });
            // @ts-ignore
            setKeyValues(keyValues.map(kv => kv.id === result.data.id ? result.data : kv));
        } catch (error) {
            // @ts-ignore
            alert(t('keyValue.errorPrefix', { message: (error as Error).message }));
        }
    };
    const handleApplyToAll = async () => {
        if (!window.confirm(t('keyValue.confirmApplyAll'))) return;

        try {
            setIsApplying(true);
            await authService.applyKeyValuesToAllUsers(userId);
            alert(t('keyValue.applySuccess'));
        } catch (error) {
            console.error('Ошибка:', error);
            // @ts-ignore
            alert(t('keyValue.errorPrefix', { message: (error as Error).message }));
        } finally {
            setIsApplying(false);
        }
    };
    // @ts-ignore
    return (
        <Box>
            {isLoading ? (
                <CircularProgress />
            ) : (
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('keyValue.key')}</TableCell>
                                    <TableCell>{t('keyValue.value')}</TableCell>
                                    <TableCell>{t('keyValue.actions')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {keyValues.length > 0 ? (
                                    keyValues.map((kv) => (
                                        <TableRow key={kv.id}>
                                            <TableCell>{kv.key}</TableCell>
                                            <TableCell>
                                                <TextField
                                                    value={kv.value}
                                                    //onChange={(e) => handleUpdate(kv.key, e.target.value)}
                                                    size="small"
                                                    disabled={true}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <IconButton onClick={() => handleDelete(kv.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                                <Tooltip title={t('common.edit')}>
                                                    <IconButton onClick={() => setEditingItem(kv)} color="primary">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            {isLoading ? t('common.loading') : t('common.noData')}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {editingItem && (
                        <Dialog open fullWidth maxWidth="md">
                            <DialogTitle>{t('keyValue.editTitle', { key: editingItem.key })}</DialogTitle>
                            <DialogContent>
                                <Box mt={2} display="flex" flexDirection="column" gap={2}>
                                    <TextField
                                        multiline
                                        fullWidth
                                        minRows={20}
                                        maxRows={30}
                                        value={editingItem.value}
                                        onChange={(e) => setEditingItem({...editingItem, value: e.target.value})}
                                        variant="outlined"
                                    />
                                    {/* Поле описания */}
                                    <TextField
                                        label={t('keyValue.description')}
                                        multiline
                                        fullWidth
                                        minRows={2}
                                        maxRows={4}
                                        value={editingItem.description || ''}
                                        onChange={(e) => setEditingItem({...editingItem, description: e.target.value})}
                                        variant="outlined"
                                    />
                                    {/* Поле для загрузки картинки */}
                                    <Box>
                                        <Typography variant="body2" gutterBottom>
                                            {t('keyValue.image')}
                                        </Typography>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id="edit-image-upload"
                                            type="file"
                                            onChange={(e) => handleEditImageUpload(e, editingItem)}
                                        />
                                        <label htmlFor="edit-image-upload">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                startIcon={<CloudUploadIcon />}
                                                fullWidth
                                            >
                                                {editingItem.imageBase64 ? t('keyValue.replaceImage') : t('keyValue.chooseImage')}
                                            </Button>
                                        </label>

                                        {/* Предпросмотр изображения */}
                                        {editingItem.imageBase64 && (
                                            <Box mt={1} display="flex" flexDirection="column" alignItems="center">
                                                <img
                                                    src={`data:${editingItem.imageMimeType};base64,${editingItem.imageBase64}`}
                                                    alt={t('keyValue.preview')}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '200px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd'
                                                    }}
                                                />
                                                <Button
                                                    size="small"
                                                    color="error"
                                                    onClick={() => handleRemoveEditImage(editingItem)}
                                                    sx={{ mt: 1 }}
                                                >
                                                    {t('keyValue.removeImage')}
                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setEditingItem(null)}>{t('common.cancel')}</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={async () => {
                                        await handleUpdate(
                                            editingItem.key,
                                            editingItem.value,
                                            editingItem.description,
                                            editingItem.imageBase64,
                                            editingItem.imageMimeType
                                        );
                                        setEditingItem(null);
                                    }}
                                >
                                    {t('common.save')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                    <Box mt={2} display="flex" gap={1}>

                        {/*<TextField
                            label="Значение"
                            value={newValue}
                            onChange={(e) => setNewValue(e.target.value)}
                            size="small"
                        />*/}
                        <Button
                            variant="contained"
                            onClick={()=>setAddingItem(true)}
                            //disabled={!newKey.trim()}
                        >
                            {t('common.add')}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleApplyToAll}
                        >
                            {t('keyValue.applyAll')}
                        </Button>

                    </Box>

                    {addingItem && (
                        <Dialog open fullWidth maxWidth="md">
                            <DialogTitle>{t('keyValue.addTitle')}</DialogTitle>

                            <DialogContent>
                                <Box mt={2} display="flex" flexDirection="column" gap={1}>
                                    <TextField
                                        label={t('keyValue.newKey')}
                                        value={newKey}
                                        onChange={(e) => setNewKey(e.target.value)}
                                        size="small"
                                    />

                                    <TextField
                                        multiline
                                        fullWidth
                                        minRows={20}
                                        maxRows={30}
                                        value={newValue}
                                        onChange={(e) => setNewValue(e.target.value)}
                                        variant="outlined"
                                    />

                                    {/* Поле для описания */}
                                    <TextField
                                        label={t('keyValue.description')}
                                        multiline
                                        fullWidth
                                        minRows={2}
                                        maxRows={4}
                                        value={newDescription || ''}
                                        onChange={(e) => setNewDescription(e.target.value)}
                                        variant="outlined"
                                    />
                                    {/* Поле для загрузки картинки */}
                                    <Box>
                                        <Typography variant="body2" gutterBottom>
                                            {t('keyValue.image')}
                                        </Typography>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id="image-upload"
                                            type="file"
                                            onChange={handleImageUpload}
                                        />
                                        <label htmlFor="image-upload">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                startIcon={<CloudUploadIcon />}
                                                fullWidth
                                            >
                                                {t('keyValue.chooseImage')}
                                            </Button>
                                        </label>

                                        {/* Предпросмотр изображения */}
                                        {newImageBase64 && (
                                            <Box mt={1} textAlign="center">
                                                <img
                                                    src={newImageBase64}
                                                    alt={t('keyValue.preview')}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '200px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd'
                                                    }}
                                                />
                                                <Box
                                                    display="flex"
                                                    justifyContent="center"
                                                    mt={1}
                                                >
                                                    <Button
                                                        size="small"
                                                        color="error"
                                                        onClick={handleRemoveImage}
                                                    >
                                                        {t('keyValue.removeImage')}
                                                    </Button>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setAddingItem(null)}>{t('common.cancel')}</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={async () => {
                                        await handleAdd();
                                        setAddingItem(false)
                                    }}
                                >
                                    {t('common.save')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </>
            )}
        </Box>
    );
};

const ReportsComponent = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 10,
    });
    useEffect(() => {
        setPagination((p) => ({ ...p, pageIndex: 0 }));
    }, [id]);
    const {
        data: reportsPage,
        isError: isLoadingUsersError,
        isFetching: isFetchingUsers,
        isLoading: isLoadingUsers,
        refetch
    } = useGetReportsAdmin(Number(id), pagination.pageIndex, pagination.pageSize);
    const fetchedReports = reportsPage?.items ?? [];
    const reportsTotal = reportsPage?.total ?? 0;
    // @ts-ignore
    const [selectedUser, setSelectedUser] = useState<UserPair>(null);
    const [keyValueModalOpen, setKeyValueModalOpen] = useState(false);
    const [promptsModalOpen, setPromptsModalOpen] = useState(false);

    //DELETE action
    const openDeleteConfirmModal = (row: MRT_Row<Reports>) => {
        if (window.confirm(t('reports.deleteEcgConfirm'))) {
            const payload = {
                value: row.original.value,
                pin: row.original.pin
            };
            reportsService.delete(payload).then(()=>{
                refetch();
            });
        }
    };
    const [loadingRowsXls, setLoadingRowsXls] = useState<Record<number, boolean>>({});
    const [loadingRowsPdf, setLoadingRowsPdf] = useState<Record<number, boolean>>({});
    const [loadingRowsShortPdf, setLoadingRowsShortPdf] = useState<Record<number, boolean>>({});
    const [user, setUser] = useState<{
        gender?: number;
        last_name?: string;
        id?: number;
        first_name?: string;
        weight?: number;
        height?: number;
        age?: number;
        middle_name?: string;
        manager?: { id?: number; first_name?: string; last_name?: string } | null;
        managerId?: number | null;
    }>({
        gender: undefined,
        last_name: undefined,
        id: undefined,
        first_name: undefined,
        weight: undefined,
        height: undefined,
        age: undefined,
        middle_name: undefined,
        manager: null,
        managerId: null,
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [allUsers, setAllUsers] = useState<Users[]>([]);
    const [selectedManagerId, setSelectedManagerId] = useState<number | null>(null);
    const [savingManager, setSavingManager] = useState(false);

    const managerOptions = useMemo(
        () => allUsers.filter((u) => Number(u.id) !== Number(user.id)),
        [allUsers, user.id],
    );
    const selectedManager =
        managerOptions.find((u) => Number(u.id) === Number(selectedManagerId)) ?? null;

    const reloadUser = () => {
        authService.getUserById(Number(id)).then((res) => {
            const data = res?.data;
            setUser(data);
            const mid = data?.manager?.id ?? data?.managerId ?? null;
            setSelectedManagerId(mid != null ? Number(mid) : null);
        });
    };

    useEffect(() => {
        reloadUser();
    }, [id]);

    useEffect(() => {
        authService
            .getAccessContext()
            .then((res) => setIsAdmin(!!res?.data?.isAdmin))
            .catch(() => setIsAdmin(false));
    }, []);

    useEffect(() => {
        if (!isAdmin) return;
        authService
            .getUsers()
            .then((res) => setAllUsers(Array.isArray(res?.data) ? res.data : []))
            .catch(() => setAllUsers([]));
    }, [isAdmin]);

    const handleSaveManager = async () => {
        if (!user?.id) return;
        setSavingManager(true);
        try {
            await authService.setManager(Number(user.id), selectedManagerId);
            toast.success(t('users.managerSaved'));
            reloadUser();
        } catch (err) {
            toast.error(getErrorMessage(err, t('users.managerSaveFailed')));
        } finally {
            setSavingManager(false);
        }
    };
    const handleRowXls = async (report: Reports) => {
        setLoadingRowsXls((prev) => ({ ...prev, [report.id]: true }));
        try {
            await downloadReportXls(report, user);
        } catch (err) {
            toast.error(getErrorMessage(err, t('reportDetail.xlsFailed')));
        } finally {
            setLoadingRowsXls((prev) => ({ ...prev, [report.id]: false }));
        }
    };
    const handleRowPdf = async (report: Reports, short: boolean) => {
        const userId = Number(id);
        if (!userId) return;
        const setLoading = short ? setLoadingRowsShortPdf : setLoadingRowsPdf;
        setLoading((prev) => ({ ...prev, [report.id]: true }));
        try {
            await downloadReportPdf(report, userId, short);
        } catch (err) {
            toast.error(getErrorMessage(err, short ? t('reportDetail.shortPdfFailed') : t('reportDetail.pdfFailed')));
        } finally {
            setLoading((prev) => ({ ...prev, [report.id]: false }));
        }
    };
    const columns = useMemo(
        () => {
            // @ts-ignore

            // @ts-ignore
            const formatDate = (dateString: unknown) => {
                if (dateString == null) return '';
                const date = new Date(String(dateString));
                return date.toLocaleString(navigator.language, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                });
            };
            return [
                { accessorKey: 'id', header: 'Id', enableEditing: false, size: 50 },
                { accessorKey: 'time', header: 'Time', enableEditing: false, size: 50 },
                { accessorKey: 'value', header: 'value', enableEditing: false, size: 50 },
                { accessorKey: 'pin', header: 'pin', enableEditing: false, size: 50 },
                {
                    accessorKey: 'created_at',
                    header: 'created_at',
                    enableEditing: false,
                    size: 50,
                    Cell: ({ cell }: { cell: { getValue: () => unknown } }) => formatDate(cell.getValue()),
                },
                {
                    id: 'testConfiguration',
                    header: t('reports.testConfig'),
                    enableEditing: false,
                    size: 120,
                    Cell: ({ row }: { row: MRT_Row<Reports> }) => {
                        const r = row.original;
                        return (
                            r.testConfiguration?.name?.trim() ||
                            (r.testConfigurationId != null ? `#${r.testConfigurationId}` : '—')
                        );
                    },
                },
                {
                    accessorKey: 'comment',
                    header: 'comment',
                    size: 50,
                    enableEditing: true,
                    muiEditTextFieldProps: ({ row, table }: { row: MRT_Row<Reports>; table: unknown }) => ({
                        onBlur: async (event: { target: { value: string } }) => {
                            const payload = {
                                value: row.getValue('value'),
                                pin: row.getValue('pin'),
                                comment: event.target.value
                            };
                            await reportsService.postComment(payload);
                            (table as { setEditingCell: (v: null) => void }).setEditingCell(null);
                        },
                    }),
                    Cell: ({ cell }: { cell: { getValue: () => string } }) => <span>{cell.getValue()}</span>,
                },
            ];
        },
        [t],
    );





    // @ts-ignore

    // @ts-ignore
    const table = useMaterialReactTable({
        columns,
        enableEditing: true,
        editDisplayMode: 'cell',
        localization: getMrtLocalization(),
        enableSelectAll:false,
        data:fetchedReports,
        enableColumnFilterModes: false,
        enableColumnOrdering: true,
        enableColumnPinning: true,
        enableFacetedValues: true,
        enableRowActions: true,
        enableRowSelection: true,
        initialState: {
            showColumnFilters: true,
            columnPinning: {
                right: ['mrt-row-actions'],
            },
        },
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        muiSearchTextFieldProps: {
            size: 'small',
            variant: 'outlined',
        },
        muiPaginationProps: {
            color: 'secondary',
            rowsPerPageOptions: [10, 20, 30, 50, 100],
            shape: 'rounded',
            variant: 'outlined',

        },
        muiTableBodyRowProps: ({ row }) => ({
            onClick: () => id && navigate(`/dashboard/users/${id}/reports/${row.original.id}`),
            sx: { cursor: 'pointer' },
        }),
        muiBottomToolbarProps:{
            sx: {
                justifyContent: 'flex-start',
            }
        },
        enablePagination:true,
        manualPagination: true,
        rowCount: reportsTotal,
        onPaginationChange: setPagination,
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '0.25rem' }} onClick={(e) => e.stopPropagation()}>
                <Tooltip title="XLS">
                    <IconButton
                        size="small"
                        onClick={() => handleRowXls(row.original)}
                        disabled={!!loadingRowsXls[row.original.id]}
                    >
                        {loadingRowsXls[row.original.id] ? <CircularProgress size={20} /> : <DescriptionIcon />}
                    </IconButton>
                </Tooltip>
                <Tooltip title="PDF">
                    <IconButton
                        size="small"
                        onClick={() => handleRowPdf(row.original, false)}
                        disabled={!!loadingRowsPdf[row.original.id]}
                    >
                        {loadingRowsPdf[row.original.id] ? <CircularProgress size={20} /> : <PictureAsPdfIcon />}
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('reportDetail.shortPdf')}>
                    <IconButton
                        size="small"
                        onClick={() => handleRowPdf(row.original, true)}
                        disabled={!!loadingRowsShortPdf[row.original.id]}
                    >
                        {loadingRowsShortPdf[row.original.id] ? <CircularProgress size={20} /> : <ShortTextIcon />}
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('reports.deleteRow')}>
                    <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
        renderBottomToolbarCustomActions:({table})=>(
            <Box></Box>
        ),
        state: {
            isLoading: isLoadingUsers,
            pagination,
        },

    });


    const [allPoints] = useState([{ x: 0, y: 0, y1: 0, isRPeaks: false }]);

    return (
        <>

            <div className="user">
                <div className="user-data">
                    <div>
                        <img src={information}  />
                    </div>
                    {user && user.id &&(
                        <>
                            <div>
                                <p className="label">
                                    Id:
                                </p>
                                <p>
                                    {user?.id}
                                </p>
                            </div>
                            <div>
                                <p className="label">
                                    Name:
                                </p>
                                <p>
                                    {user?.last_name} {user?.first_name} {user?.middle_name}
                                </p>
                            </div>
                            <div>
                                <p className="label">
                                    Age:
                                </p>
                                <p>
                                    {user?.age}
                                </p>
                            </div>
                            <div>
                                <p className="label">
                                    Weight:
                                </p>
                                <p>
                                    {user?.weight}
                                </p>
                            </div>
                            <div>
                                <p className="label">
                                    Height:
                                </p>
                                <p>
                                    {user?.height}
                                </p>
                            </div>
                            <div>
                                <p className="label">
                                    Gender:
                                </p>
                                <p>
                                    {user?.gender===1?'Male':'Female'}
                                </p>
                            </div>
                            <div>
                                <p className="label">
                                    {t('users.manager')}:
                                </p>
                                <p>
                                    {user?.manager
                                        ? [user.manager.last_name, user.manager.first_name].filter(Boolean).join(' ')
                                          || `#${user.manager.id}`
                                        : user?.managerId != null
                                          ? `#${user.managerId}`
                                          : '—'}
                                </p>
                            </div>
                        </>
                    )}
                </div>
            </div>
            {allPoints.length>1 && (
                <CanvasGridDashboard points={allPoints} setPulsUser={()=>{}}/>
            )}

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 1.5,
                    mt: 2,
                    mb: 2,
                }}
            >
                {isAdmin && user?.id && (
                    <>
                        <Autocomplete<Users, false, false, false>
                            options={managerOptions}
                            value={selectedManager}
                            onChange={(_, next) => setSelectedManagerId(next?.id != null ? Number(next.id) : null)}
                            getOptionLabel={formatManagerOptionLabel}
                            isOptionEqualToValue={(option, current) => Number(option.id) === Number(current.id)}
                            filterOptions={(options, { inputValue }) => {
                                const q = inputValue.trim().toLowerCase();
                                if (!q) return options;
                                return options.filter((u) => {
                                    const name = [u.last_name, u.first_name, u.middle_name]
                                        .filter(Boolean)
                                        .join(' ')
                                        .toLowerCase();
                                    const email = (u.email || '').toLowerCase();
                                    const idStr = String(u.id);
                                    return (
                                        name.includes(q) ||
                                        email.includes(q) ||
                                        idStr.includes(q) ||
                                        `#${idStr}`.includes(q)
                                    );
                                });
                            }}
                            clearOnEscape
                            clearText={t('users.clearManager')}
                            ListboxProps={{ sx: { maxHeight: 280 } }}
                            sx={{ minWidth: 360, maxWidth: 520, width: 420 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('users.assignManager')}
                                    size="small"
                                    placeholder={t('users.clearManager')}
                                />
                            )}
                        />
                        <Button
                            variant="contained"
                            size="medium"
                            disabled={savingManager}
                            sx={{ height: 40 }}
                            onClick={() => { handleSaveManager().catch(() => {}); }}
                        >
                            {savingManager ? <CircularProgress size={20} color="inherit" /> : t('common.save')}
                        </Button>
                    </>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    sx={{ height: 40 }}
                    onClick={()=>{
                        setSelectedUser({id:user.id||1});
                        setKeyValueModalOpen(true);
                    }}
                >
                    {t('keyValue.userProps')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    sx={{ height: 40 }}
                    onClick={()=>{
                        setSelectedUser({id:user.id||1});
                        setPromptsModalOpen(true);
                    }}
                >
                    {t('keyValue.userPrompts')}
                </Button>
            </Box>
            <Dialog
                open={keyValueModalOpen}
                onClose={() => setKeyValueModalOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {t('keyValue.userProps')}
                </DialogTitle>
                <DialogContent>
                    {selectedUser && (
                        <KeyValueManager
                            table={table}
                            userId={selectedUser.id}
                            onClose={() => setKeyValueModalOpen(false)}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setKeyValueModalOpen(false)}>{t('common.close')}</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={promptsModalOpen}
                onClose={() => setPromptsModalOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>{t('keyValue.userPrompts')}</DialogTitle>
                <DialogContent>
                    {selectedUser && (
                        <UserPromptsManager
                            userId={selectedUser.id}
                            onClose={() => setPromptsModalOpen(false)}
                            table={table}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPromptsModalOpen(false)}>{t('common.close')}</Button>
                </DialogActions>
            </Dialog>
            <MaterialReactTable
            table={table} />
        </>
    )
};
const DashboardUser = () => {


    const theme = createTheme();

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={getDayjsLocale()}>
            <ThemeProvider theme={theme}>

                <Box
                    sx={{
                        width:'100%'
                    }}
                >

                    <ReportsComponent />
                </Box>
            </ThemeProvider>
        </LocalizationProvider>

    );
};

export default DashboardUser;
